export default __webpack_public_path__ + "static/media/img24.a857cccb.jpg";